import React from 'react';
import PropTypes from 'prop-types';

import { getClass } from '../../../utils/component-helpers';

import './checkbox.scss';

const Checkbox = props => {
  const { checked, color, onSelect, disabled } = props;

  const handleChange = e => {
    onSelect(e.target.checked);
  };

  const className = getClass('custom-checkbox', {
    [color]: !disabled && !!color,
    disabled: !!disabled,
  });

  return (
    <input
      type="checkbox"
      checked={checked}
      style={{}}
      className={className}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  color: PropTypes.string,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  checked: false,
  color: 'blue',
  onSelect: () => {},
  disabled: false,
};

export default Checkbox;
